import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const DESKTOP_QUERY = '(min-width: 768px)';

function initCollectionHeroTrio() {
    const root = document.querySelector('[data-collection-hero-trio]');

    if (!root || !window.matchMedia(DESKTOP_QUERY).matches) {
        return;
    }

    const track = root.querySelector('[data-collection-hero-trio-track]');
    const titleWrap = root.querySelector('[data-collection-hero-trio-title-wrap]');
    const scrim = root.querySelector('[data-collection-hero-trio-scrim]');
    const underline = root.querySelector('[data-collection-hero-trio-underline]');
    const left = root.querySelector('[data-hero-trio="0"]');
    const center = root.querySelector('[data-hero-trio="1"]');
    const right = root.querySelector('[data-hero-trio="2"]');

    if (!track || !titleWrap || !scrim || !underline || !left || !center || !right) {
        return;
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let hasAnimated = false;

    const setFinalState = () => {
        gsap.set(titleWrap, { y: 0, opacity: 1 });
        gsap.set(scrim, { opacity: 1 });
        gsap.set(underline, { scaleX: 1 });
        gsap.set(left, { x: 0, y: 0, opacity: 1 });
        gsap.set(right, { x: 0, y: 0, opacity: 1 });
        gsap.set(center, { scale: 1.02, transformOrigin: 'center center' });
    };

    const setInitialState = () => {
        const itemWidth = center.offsetWidth;

        gsap.set(titleWrap, {
            y: 36,
            opacity: 0,
            force3D: true,
        });
        gsap.set(scrim, { opacity: 0 });
        gsap.set(underline, { scaleX: 0, transformOrigin: 'center center' });

        if (!itemWidth) {
            return;
        }

        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 24;
        const pull = Math.max(itemWidth - gap, itemWidth * 0.55);

        gsap.set(left, {
            x: pull * 0.62,
            y: 18,
            opacity: 0.9,
            force3D: true,
        });
        gsap.set(right, {
            x: -pull * 0.62,
            y: 18,
            opacity: 0.9,
            force3D: true,
        });
        gsap.set(center, {
            scale: 0.98,
            transformOrigin: 'center center',
            force3D: true,
        });
    };

    const playAnimation = () => {
        hasAnimated = true;

        gsap.timeline({
            defaults: {
                ease: 'power3.out',
                duration: 1.35,
            },
        })
            .to(left, { x: 0, y: 0, opacity: 1 }, 0)
            .to(right, { x: 0, y: 0, opacity: 1 }, 0)
            .to(
                center,
                {
                    scale: 1.02,
                    duration: 1.5,
                    ease: 'power2.out',
                },
                0.08
            )
            .to(titleWrap, { y: 0, opacity: 1, duration: 1 }, 0.15)
            .to(scrim, { opacity: 1, duration: 0.9 }, 0.15)
            .to(
                underline,
                {
                    scaleX: 1,
                    duration: 0.85,
                    ease: 'power2.out',
                },
                0.45
            );
    };

    const setup = () => {
        ScrollTrigger.getById('collection-hero-trio')?.kill();

        if (reducedMotion) {
            setFinalState();

            return;
        }

        setInitialState();

        ScrollTrigger.create({
            id: 'collection-hero-trio',
            trigger: root,
            start: 'top 82%',
            once: true,
            onEnter: playAnimation,
        });
    };

    if (document.fonts?.ready) {
        document.fonts.ready.then(setup);
    } else {
        setup();
    }

    const centerImage = center.querySelector('img');

    if (centerImage && !centerImage.complete) {
        centerImage.addEventListener('load', () => {
            if (!hasAnimated && !reducedMotion) {
                setInitialState();
            }

            ScrollTrigger.refresh();
        }, { once: true });
    }

    window.addEventListener('resize', () => {
        if (!window.matchMedia(DESKTOP_QUERY).matches) {
            ScrollTrigger.getById('collection-hero-trio')?.kill();
            setFinalState();

            return;
        }

        ScrollTrigger.refresh();

        if (!hasAnimated && !reducedMotion) {
            setInitialState();
        }
    });
}

export default initCollectionHeroTrio;
